module.exports = __webpack_public_path__ + "static/media/MongoDB_Logo_RGB_Logo_White.e10c4f6f.svg";